import React from "react";

function ToggleSwitch({
  handleClick,
  value,
  id,
  disabled,
  name,
  checked,
  errorMessage,
}) {
  return (
    <div className=" ">
      <label className="form-switch">
        <input
          type="checkbox"
          onChange={handleClick}
          className={"form-check-input" + (!disabled ? "cursor-pointer" : "")}
          value={value}
          id={id}
          disabled={disabled}
          name={name}
          checked={checked}
        />
        <span
          className={"form-slider round" + (disabled ? " disabled" : "")}
        ></span>
      </label>
      {errorMessage && errorMessage[name] && Object?.keys(errorMessage).length > 0 && (
        <div className="text-danger fw-700 fs-6 mt-1">
          {errorMessage && errorMessage[name] && errorMessage[name]}
        </div>
      )}
    </div>
  );
}

export default ToggleSwitch;
